// extracted by mini-css-extract-plugin
export default {"configurationForm":"style_configurationForm__I6f9O","formContainer":"style_formContainer__eJm16"};